import { apiGet } from '../../utils/api';

export function getNotifications(args) {
  return apiGet('/notification_log', args);
}

export function getSNSMessageLogs(args) {
  return apiGet('/sns_message_log', args);
}
